export const faqItems = [
  {
    question: 'How does booking a stay with Royal Vista work?',
    answer: 'Booking with Royal Vista is simple and straightforward. You can browse our curated selection of premium residences, check availability, and book directly through our platform. Our team ensures each property meets our high standards for quality, design, and location.',
  },
  {
    question: 'Can I list my property with Royal Vista?',
    answer: 'Yes, we welcome property owners who are interested in listing their residences with Royal Vista. Our team carefully evaluates each property to ensure it meets our standards for luxury, comfort, and exceptional guest experience. Contact us to learn more about the listing process.',
  },
  {
    question: 'Are the properties professionally managed?',
    answer: 'All Royal Vista properties are professionally managed to ensure consistency, reliability, and attention to detail at every stage of your stay. From the initial booking to departure, our management team is dedicated to providing exceptional service and maintaining the highest standards.',
  },
  {
    question: 'Who can I contact if I need assistance?',
    answer: 'Our dedicated support team is available to assist you with any questions or concerns before, during, and after your stay. You can reach out through our contact form, email, or phone, and we\'ll be happy to help ensure your experience is seamless and enjoyable.',
  },
  {
    question: 'What standards do Royal Vista residences follow?',
    answer: 'Royal Vista residences adhere to strict standards covering quality, design, cleanliness, amenities, and location. Each property is carefully selected and maintained to provide comfort, elegance, and exceptional stays. We regularly inspect and update our properties to ensure they meet these standards.',
  },
  {
    question: 'Do you offer short and extended stays?',
    answer: 'Yes, Royal Vista offers both short-term and extended stay options to accommodate various travel needs. Whether you\'re planning a weekend getaway or a longer-term stay, we have flexible options available. Check individual property listings for specific availability and terms.',
  },
  {
    question: 'What should I expect during my stay?',
    answer: 'During your stay at a Royal Vista property, you can expect a refined living experience with premium amenities, thoughtful design, and professional management. Each residence is prepared with attention to detail, ensuring comfort, ease, and peace of mind throughout your visit.',
  },
];

